import { render, staticRenderFns } from "./RevenueRecognitionView.vue?vue&type=template&id=65dfbaa8&scoped=true"
import script from "./RevenueRecognitionView.vue?vue&type=script&lang=js"
export * from "./RevenueRecognitionView.vue?vue&type=script&lang=js"
import style0 from "./RevenueRecognitionView.vue?vue&type=style&index=0&id=65dfbaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfbaa8",
  null
  
)

export default component.exports